// extracted by mini-css-extract-plugin
module.exports = {"div":"SectionDivider-module__div___3QAS1","divV2":"SectionDivider-module__divV2___1cDK2"};